export default class AlMediaManagerController {

    constructor($scope, $injector) {
        this.scope = $scope;
        this.injector = $injector;

        this.api = this.injector.get('$http');
        this.translate = this.injector.get('$translate');
        this.currentDirectory = null;
        this.preSelectedFileUuid = null;
        this.enableFileSelection = false;
        this.directoryTree = [];
        this.refresh = () => this._refreshData();
        this.loadingStates = {
            content: true,
            tree: true
        };

        this._resetError();
    }

    $onInit() {
        this._refreshData();
        this.refresh = () => this._refreshData();
    }

    handleDirectoryClick(newDirectory, fresh = false) {
        this.currentDirectory = newDirectory.uuid;

        if (fresh) {
            this._reloadDirectoryTree();
            return;
        }

        if (_.filter(this.rawDirectories, (directory) => {
            return directory.uuid === newDirectory.uuid;
        }).length === 0) {
            this._reloadDirectoryTree();
        }
    }

    handleDirectoryFileSelection(file) {
        this.onFileSelection({file});
    }

    // Privat functions
    _refreshData() {
        this._reloadDirectoryTree();
    }

    _reloadDirectoryTree() {
        this.loadingStates.tree = true;

        this.api.get('media/directories/as-tree').then((response) => {
            this.directoryTree = [];
            this.rawDirectories = response.data.data;

            this.rawDirectories = this.rawDirectories.sort(function (a, b) {
                return a.name.localeCompare(b.name);
            });

            const directoriesByUuid = {},
                tempDirectoryTree = [];

            _.each(this.rawDirectories, (directory) => {
                directoriesByUuid[directory.uuid] = {
                    uuid: directory.uuid,
                    name: directory.name,
                    childDirectories: []
                };
            });

            _.each(this.rawDirectories, (directory) => {
                    const directoryEntry = directoriesByUuid[directory.uuid];

                    if (_.isNull(directory.parentUuid)) {
                        tempDirectoryTree.push(directoryEntry);
                    } else {
                        directoriesByUuid[directory.parentUuid].childDirectories.push(directoryEntry);
                    }
                }
            )

            this.directoryTree = [
                {
                    uuid: null,
                    name: this._getTranslationValue('root-directory-label'),
                    childDirectories: tempDirectoryTree
                }
            ];

            this.loadingStates.tree = false;
        }, () => {
            this._setError();
        })
    }

    _setError(message) {
        this.error = {
            active: true,
            message
        }
    }

    _resetError() {
        this.error = {
            active: false,
            message: ''
        }
    }

    _getTranslationValue(path) {
        return this.translate.instant(`media.components.media-manager.${path}`);
    }
}

AlMediaManagerController.$inject = [
    '$scope',
    '$injector'
];



// WEBPACK FOOTER //
// ./src/app/modules/media/components/al-media-manager/controller.js